import { localized } from "@msuite/ui/localization";
import { createColumnHelper } from "@msuite/ui/table";
import type { ContactMember } from "@msuite/utils/types";
import { columns as projectContactColumns } from "@/sites/projects/project/panels/project-contacts/table-config";
import { SubstitutionPlanMemberContactNotificationSwitch } from "./substitution-plan-member-contact-notification-switch";

const columnHelper = createColumnHelper<ContactMember>();

export const columns = [
	columnHelper.display({
		id: "include",
		header: localized("substitutions.notify"),
		cell: (cell) => (
			<SubstitutionPlanMemberContactNotificationSwitch contactMember={cell.row.original} />
		),
	}),
].concat(projectContactColumns as any);
